import {Card} from 'platform/components';
import {HStack, Text, VStack} from 'platform/foundation';

import {type RequiredTestIdProps, suffixTestId} from 'shared/web';

import type {AbcXyzMetric} from '../types/AbcXyzMetric';

interface AbcXyzMetricsCardProps extends RequiredTestIdProps {
  title: string;
  metrics: AbcXyzMetric[];
}

export function AbcXyzMetricsCard(props: AbcXyzMetricsCardProps) {
  return (
    <Card isFullHeight data-testid={props['data-testid']}>
      <VStack spacing={2}>
        <Text size="small" alternative>
          {props.title}
        </Text>
        {props.metrics.map((metric) => (
          <HStack
            key={metric.id}
            justify="space-between"
            spacing={2}
            align="baseline"
            data-testid={suffixTestId(metric.id, props)}
          >
            <Text size="xSmall" color="secondary">
              {metric.label}
            </Text>
            <Text size="small" alternative align="right">
              {metric.value}
            </Text>
          </HStack>
        ))}
      </VStack>
    </Card>
  );
}
